<div class="relative">
  <button
    type="button"
    (click)="toggle()"
    [disabled]="updating"
    class="flex items-center gap-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-1.5 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-60"
    [title]="currentOption().description">
    <span class="relative flex h-2.5 w-2.5">
      <span class="absolute inline-flex h-full w-full rounded-full opacity-75" [class]="currentOption().color"></span>
      <span class="relative inline-flex rounded-full h-2.5 w-2.5" [class]="currentOption().color"></span>
    </span>
    <span class="hidden sm:inline">{{ currentOption().label }}</span>
    <svg class="h-3 w-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
    </svg>
  </button>

  @if (open) {
  <div class="absolute right-0 mt-2 w-64 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-lg z-dropdown overflow-hidden">
    <div class="px-3 py-2 border-b border-gray-100 dark:border-gray-700">
      <p class="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Mi presencia</p>
      @if (presence) {
      <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
        Llamadas activas: {{ presence.activeCalls }}/{{ presence.maxConcurrentCalls }}
      </p>
      }
    </div>
    <div class="py-1">
      @for (opt of options; track opt.value) {
      <button
        type="button"
        (click)="select(opt)"
        class="w-full flex items-start gap-3 px-3 py-2 text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800"
        [class.bg-brand-50]="presence?.presenceStatus === opt.value"
        [class.dark:bg-brand-500\/10]="presence?.presenceStatus === opt.value">
        <span class="relative flex h-2.5 w-2.5 mt-1.5">
          <span class="relative inline-flex rounded-full h-2.5 w-2.5" [class]="opt.color"></span>
        </span>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ opt.label }}</p>
          <p class="text-xs text-gray-500 dark:text-gray-400">{{ opt.description }}</p>
        </div>
        @if (presence?.presenceStatus === opt.value) {
        <svg class="h-4 w-4 text-brand-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        }
      </button>
      }
    </div>
  </div>
  }
</div>
